import { Directive, ElementRef, HostListener, Input } from '@angular/core';



declare var $: any;
declare var jQuery: any;
declare var autosize: any

@Directive({
  selector: '[OnlyNumber]'
})
export class OnlyNumber {
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  constructor(private el: ElementRef) { }

  @Input() OnlyNumber: boolean;

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    let e = <KeyboardEvent>event;
    if (this.OnlyNumber) {
      // if ([46, 8, 9, 27, 13, 190].indexOf(e.keyCode) !== -1 ||
      //   // Allow: Ctrl+A
      //   (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      //   // Allow: Ctrl+C
      //   (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      //   // Allow: Ctrl+V
      //   (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      //   // Allow: Ctrl+X
      //   (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      //   // Allow: home, end, left, right
      //   (e.keyCode >= 35 && e.keyCode <= 39)) {
      //     // let it happen, don't do anything
      //     return;
      //   }
      //   // Ensure that it is a number and stop the keypress
      //   if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105) || (e.keyCode===110)) {
      //       e.preventDefault();
      //   }

      // }

      if ((e.keyCode > 47 && e.keyCode < 58) || (e.keyCode == 109) || (e.keyCode > 95 && e.keyCode < 106) || (e.keyCode > 34 && e.keyCode < 41) || (e.keyCode == 16) || (e.keyCode == 46) || (e.keyCode == 9)) {

        if (((e.keyCode > 47 && e.keyCode < 58) || (e.keyCode > 95 && e.keyCode < 106)) && this.numList.indexOf(e.key) == -1) {
          e.preventDefault();
        }

        if ((event.target.value + e.key).length > 3) {
          e.preventDefault();
        }
     
      }
      else {
        if (e.keyCode != 0 && e.keyCode != 8 && e.keyCode != 13 && !e.ctrlKey) {
          e.preventDefault();
        }
      }
    }
  }
}